// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'google';

export const Component = () => (
  <path d='M19.99 12.854c0 1.484-.288 2.73-.91 3.831-.575 1.102-1.437 2.012-2.586 2.682-1.102.623-2.395.958-3.832.958a7.515 7.515 0 0 1-2.969-.623c-.862-.335-1.677-.91-2.442-1.628a6.434 6.434 0 0 1-1.628-2.442A7.666 7.666 0 0 1 5 12.662c0-1.053.24-2.059.623-2.969a7.51 7.51 0 0 1 1.628-2.442c.718-.718 1.58-1.293 2.442-1.628A7.512 7.512 0 0 1 12.663 5c2.011 0 3.687.67 5.124 2.012L15.68 9.023c-.767-.814-1.772-1.197-3.018-1.197-.861 0-1.628.239-2.394.67a4.95 4.95 0 0 0-1.724 1.724 5.14 5.14 0 0 0-.623 2.442c0 .91.24 1.725.623 2.443a4.95 4.95 0 0 0 1.724 1.724c.766.431 1.533.67 2.394.67.527 0 1.054-.096 1.581-.239.383-.144.814-.335 1.198-.623.382-.335.67-.575.814-.814.191-.191.335-.478.526-.861.096-.192.144-.432.192-.767h-4.31v-2.634h7.183c.096.431.144.862.144 1.293Z' />
);

export const viewBox = '0 0 25 25';
